import { FC, useState, ReactNode, useRef, useCallback, useEffect } from 'react';
import './style.scss';
import {
    Button,
    Upload,
    UploadProps,
    message,
    UploadFile,
    Tooltip,
    Modal,
    ModalProps,
    Radio
} from 'antd';
import {
    UploadOutlined,
    EyeOutlined,
    FileOutlined,
    DeleteOutlined,
    ExclamationCircleOutlined
} from '@ant-design/icons';
import { FileType } from '../enum';
import Draggable from 'react-draggable';
import type { DraggableData, DraggableEvent } from 'react-draggable';
import { uploadApi, uploadSubmitApi, submitApplyApi } from '../../api';
import ImgPreview from '../imgPreview';
import ApplyList from '../applyList';
import SampleList from '../sampleList';

type TableData = {
    fileName: string;
    uploadResult?: UploadFile<File>[];
    type: FileType;
    subText?: string;
};

interface PropsType {
    next: (index: number, key?: string, patam?: any) => void;
    nextParam: Record<string, any>;
    options: Record<string, any>[];
    tableData: TableData[];
    setTableData: (e: any) => void;
    uuid: Record<string, any>;
}

const Material: FC<PropsType> = ({
    next = () => {},
    nextParam = {},
    tableData = [],
    setTableData = () => {},
    options = [],
    uuid = ''
}) => {
    const columns = [
        {
            title: '序号',
            width: '5%',
            filed: 'index'
        },
        {
            title: '材料名称',
            width: '30%',
            filed: 'fileName'
        },
        {
            title: '操作',
            width: '15%',
            filed: 'bz'
        }
    ];
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [ModalContent, setModalContent] = useState<ReactNode>(null);
    const [modalProps, setModalProps] = useState<ModalProps>({});
    const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 });
    const draggleRef = useRef<HTMLDivElement>(null);
    const [zjIndex, setZJIndex] = useState<string>('1');
    const [demoType, setDemoType] = useState<string | null>("ggcpyj");
    const [imgData, setImgData] = useState<Record<string, any>[]>([]);
    const [openModal, setOpenModal] = useState(false);
    const [openGgcpyj, setOpenGgcpyj] = useState(false);
    useEffect(() => {
      
        if(demoType===FileType.GGCPYJ){
           
        showExampleGgcpyj(FileType.GGCPYJ)
    }
        if (!open) return;
        
        setImgData(
            zjIndex === '1'
                ? [
                      {
                          url: require('../../img/2.png'),
                          title: '医疗机构执业许可证[正本] (示例) ↑↑↑'
                      },
                      {
                          url: require('../../img/1.png'),
                          title: '医疗机构执业许可证[副本] (示例) ↑↑↑'
                      }
                  ]
                : [
                      {
                          url: require('../../img/3.jpg'),
                          title: '诊所备案凭证 (示例) ↑↑↑'
                      }
                  ]
        );
    }, [zjIndex, open]);

    const uplodaProps: UploadProps = {
        customRequest: async ({ file, data: param }) => {
            try {
                updateFileList(file as UploadFile, param);
                message.success('文件上传成功！');
            } catch (error) {
                message.error('文件上传失败！');
            }
        },
        beforeUpload: (file) => {
            const imgs = ['image/png', 'image/JPEG', 'image/jpg', 'image/jpeg', 'application/pdf'];
            const isImg = imgs.includes(file.type);
            if (!isImg) message.error(`${file.name} 文件格式不支持，请上传(png/jpg/jpeg/pdf)格式`);
            return isImg || Upload.LIST_IGNORE;
        },
        fileList: [],
        multiple: true
    };

    // 更新文件上传列表
    function updateFileList(file: UploadFile, data: Record<string, unknown> | undefined = {}) {
        const newData = tableData.map((item) => {
            if (item.type === data.type) item.uploadResult?.push(file);
            return { ...item };
        });
        setTableData(newData);
    }

    // 加载文件生成base64
    async function readFileAsDataURL(file: UploadFile<File> | null) {
        if (!file) return;
        let result_base64 = await new Promise((resolve) => {
            let fileReader = new FileReader();
            fileReader.onload = (e) => resolve(fileReader.result);
            fileReader.readAsDataURL(file as any);
        });
        return result_base64;
    }

    // 生成样件成品图片数据
    async function createImgData(tableData: TableData[]) {
        const [itemData] = tableData.filter((item) => item.type === FileType.BANNER);
        const data: Record<string, any>[] = [];
        for (let i = 0; i < (itemData.uploadResult?.length || 0); i++) {
            const file = itemData?.uploadResult ? itemData?.uploadResult[i] : null;
            const url = await readFileAsDataURL(file);
            data.push({ url, type: [(file as any)?.yj_type] });
        }
        return data;
    }

    // 删除文件
    async function deleteFile(param: any) {
        tableData.forEach(({ type, uploadResult = [] }, index) => {
            if (type !== param.type) return;
            const i = uploadResult?.findIndex((item) => item.name === param.name);
            if (i === -1) return false;
            tableData[index].uploadResult?.splice(i as number, 1);
            return false;
        });
        setTableData([...tableData]);
    }

    // 渲染文件上传组件
    function renderUpload(data: Record<string, unknown>, uploadResult: UploadFile[]): ReactNode {
        const renderTile: ReactNode = uploadResult.length ? (
            <div className='file-list-box'>
                {uploadResult.map(({ name, uid }) => (
                    <div className='file-item' key={uid}>
                        <FileOutlined />
                        <span className='file-name' title={name}>
                            {name}
                        </span>
                        <div
                            className='del-item'
                            title='删除'
                            onClick={deleteFile.bind(null, { name, type: data.type })}
                        >
                            <DeleteOutlined />
                        </div>
                    </div>
                ))}
            </div>
        ) : null;

        return (
            <Tooltip title={renderTile} placement='bottom' color='#0094fe'>
                <Upload {...uplodaProps} data={data} className='upload-box'>
                    <span className='btn'>
                        <UploadOutlined />
                        上传({uploadResult?.length})
                    </span>
                </Upload>
            </Tooltip>
        );
    }
    // 显示参考示例
    const showExample = (type: string) => {
        setDemoType(type + 'Example');
        setModalContent(null);
        setModalProps({
            width: 1000,
            className: 'ant-modal-body-example',
            title:
                type === FileType.PERMIT ? (
                    <span style={{ color: 'red' }}>根据医疗机构所持证件情况，上传相关证件</span>
                ) : null
        });
        setOpen(true);
    };
     // 广告成品样件示例
     const showExampleGgcpyj = (type:FileType) => {
            setDemoType(type)
            if(demoType===FileType.GGCPYJ){
                setOpenGgcpyj(true)
            }
    };
    // 图片及PDF预览
    const showPreview = useCallback(
        async (type: FileType) => {
            switch (type) {
                case FileType.APPLY:
                    setModalContent(<ApplyList options={options} data={nextParam.appData} />);
                    break;
                case FileType.SAMPLE:
                    const imgData = await createImgData(tableData);
                    // setModalContent(<ProveList data={nextParam.appData} options={options} />);
                    setModalContent(
                        <SampleList options={options} data={nextParam.appData} imgData={imgData} />
                    );
                    break;
                case FileType.BANNER:
                case FileType.PERMIT:
                    const [item] = tableData.filter((item) => item.type === type);
                    if (!item.uploadResult || item.uploadResult.length === 0) return false;
                    setModalContent(<ImgPreview uploadResult={item.uploadResult} />);
                    break;
            }
            setDemoType(null);
            setModalProps({
                width: type === FileType.BANNER || type === FileType.PERMIT ? 600 : 1000,
                className: 'ant-modal-body-preview'
            });
            setOpen(true);
        },
        [tableData]
    );
    // 取消隐藏弹窗
    const handleCancel = () => {
        setOpen(false);
    };

    const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
        const { clientWidth, clientHeight } = window.document.documentElement;
        const targetRect = draggleRef.current?.getBoundingClientRect();
        if (!targetRect) {
            return;
        }
        setBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top + uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y)
        });
    };
    // 保存进入下一步
    async function submit() {
        for (let i = 0; i < tableData.length; i++) {
            if (!tableData[i].uploadResult?.length) {
                setOpenModal(false);
                return message.error(`必传材料不能为空`);
            }
        }
        setLoading(true);
        setOpenModal(false);
        try {
            // 上传医疗机构执行许可证
            const licenseFormData = new FormData();
            const { uploadResult } = tableData.filter(({ type }) => type === FileType.PERMIT)[0];
            uploadResult?.forEach((file: any) => licenseFormData.append('files', file));
            const license = await uploadApi(licenseFormData);
            // 四川省中医医疗广告审查申请表
            const applyFormData = new FormData();
            const { uploadResult: applyResult } = tableData.filter(
                ({ type }) => type === FileType.APPLY
            )[0];
            applyResult?.forEach((file: any) => applyFormData.append('files', file));
            const apply = await uploadApi(applyFormData);
            // 上传医疗广告成品样件表
            const sampleFormData = new FormData();
            const { uploadResult: sampleResult } = tableData.filter(
                ({ type }) => type === FileType.SAMPLE
            )[0];
            sampleResult?.forEach((file: any) => sampleFormData.append('files', file));
            const sample = await uploadApi(sampleFormData);
            const id = nextParam.id ? nextParam.id : '';
            const { code, message: msg } = await uploadSubmitApi({
                applyFiles: apply?.data,
                licenseFiles: license?.data,
                sampleFiles: sample?.data,
                id
            });

            if (code !== 200) {
                setLoading(false);
                return message.error(`${msg}`);
            }
            const { message: submitMessage, code: submitCode } = await submitApplyApi({ id ,uuid});
            if (submitCode !== 200) {
                setLoading(false);
                return message.error(`${submitMessage}`);
            }

            next(6, 'success', submitCode === 200);
        } catch (error) {
            setLoading(false);
            message.error(`提交申请失败！`);
        }
    }

    function openModals() {
        setOpenModal(true);
    }

    return (
        <div className='box material-box'>
            <div className='text-title'>
                <span className='line'></span>
                <span>提交部门审查</span>
            </div>
            <div className='text-title-line'></div>
            <div>
                <table className='table table-responsive' align='center'>
                    <tbody>
                        <tr>
                            {columns.map(({ title, width, filed }) => (
                                <td className='bl-bg text-tag' width={width} key={filed}>
                                    {title}
                                </td>
                            ))}
                        </tr>
                    </tbody>
                    <tbody className='text-tag'>
                        {tableData.map(({ fileName, uploadResult, type, subText }, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td style={{ whiteSpace: 'nowrap' }}>
                                    {fileName}
                                    {subText ? (
                                        <span
                                            style={{
                                                color: 'red',
                                                fontWeight: 'bold',
                                                marginLeft: '5px'
                                            }}
                                        >
                                            {subText}
                                        </span>
                                    ) : null}
                                </td>
                                <td>
                                    {renderUpload({ type }, uploadResult || [])}
                                    {index < 1 ? (
                                        <span
                                            className='btn'
                                            onClick={showExample.bind(null, type)}
                                        >
                                            参考示例
                                        </span>
                                    ) : null}
                                    {index < 1 ? (
                                        <span
                                            className='btn'
                                            onClick={showPreview.bind(null, type)}
                                        >
                                            <EyeOutlined />
                                            预览
                                        </span>
                                    ) : null}
                                     {index ===2 ? (
                                        <span
                                            className='btn'
                                            onClick={showExampleGgcpyj.bind(null, FileType.GGCPYJ)}
                                        >
                                            参考示例
                                        </span>
                                    ) : null}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div>
                <Button
                    onClick={() => next(0)}
                    type='primary'
                    style={{ width: 140, marginTop: 15, height: 35, marginRight: 15 }}
                    disabled={loading}
                >
                    填写申请表
                </Button>
                <Button
                    onClick={openModals}
                    loading={loading}
                    type='primary'
                    style={{
                        width: 140,
                        marginTop: 15,
                        height: 35,
                        backgroundColor: '#FFC000',
                        border: 'none'
                    }}
                >
                    下一步
                </Button>
            </div>

            <Modal
                title={null}
                open={open}
                footer={null}
                {...modalProps}
                onCancel={handleCancel}
                width={1400}
                destroyOnClose={true}
                modalRender={(modal) => (
                    <Draggable
                        bounds={bounds}
                        nodeRef={draggleRef}
                        onStart={(event, uiData) => onStart(event, uiData)}
                    >
                        <div ref={draggleRef}>{modal}</div>
                    </Draggable>
                )}
            >
                {demoType === FileType.BANNER + 'Example' ? (
                    <img
                        src={require('../../img/ggyj.jpg')}
                        className='ck-view-img'
                        draggable='false'
                        alt='参考示例'
                    />
                ) : null}
                {demoType === FileType.PERMIT + 'Example' ? (
                    <>
                        <div className='w-full top-btn-box'>
                            <Radio.Group
                                value={zjIndex}
                                onChange={(e) => setZJIndex(e.target.value)}
                            >
                                <Radio.Button value='1'>情况1：医疗机构执业许可证</Radio.Button>
                                <Radio.Button value='2'>情况2：诊所证件</Radio.Button>
                            </Radio.Group>
                        </div>
                        <div className='img-box w-full'>
                            {zjIndex === '1' ? (
                                <div
                                    style={{
                                        textAlign: 'left',
                                        padding: '10px 30px',
                                        fontSize: '16px'
                                    }}
                                >
                                    需上传
                                    <span style={{ color: 'red' }}>
                                        《医疗机构执业许可证(正本)》
                                    </span>
                                    和
                                    <span style={{ color: 'red' }}>
                                        《医疗机构执业许可证 (副本)》
                                    </span>
                                    ，详见下方示例:
                                </div>
                            ) : (
                                <div
                                    style={{
                                        textAlign: 'left',
                                        padding: '10px 30px',
                                        fontSize: '16px'
                                    }}
                                >
                                    需上传<span style={{ color: 'red' }}>《诊所备案证》</span>
                                    ，详情见下方示例:
                                </div>
                            )}

                            {imgData.map(({ url, title }, index) => (
                               <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                               <img
                                   src={url}
                                   className='ck-view-img'
                                   draggable='false'
                                   alt='参考示例'
                                   style={{ width: '50%' }}
                               />
                               <div style={{ marginBottom: '15px', fontWeight: 'bold', textAlign: 'center' }}>
                                   {title}
                               </div>
                           </div>
                            ))}
                        </div>
                    </>
                ) : null}
                {ModalContent}


            </Modal>

            <Modal
                title={
                    <div>
                        <span style={{ color: ' #faad14', fontSize: '20px', marginRight: '15px' }}>
                            <ExclamationCircleOutlined />
                        </span>
                        温馨提示
                    </div>
                }
                open={openModal}
                footer={[
                    <Button type='primary' onClick={submit}>
                        我已知晓
                    </Button>
                ]}
                onCancel={() => setOpenModal(false)}
                destroyOnClose={true}
                width={550}
                style={{ top: '30%' }}
            >
                <div style={{ fontSize: '18px', textIndent: '2ch' }}>
                申请将在8个工作日内审查完成，申请人可在医疗广告新办审批系统首页‘查看医疗广告审查受理进度’处查看办理流程和结果。
                </div>
                {/* <div style={{ fontSize: '18px' }}>
                    2、网上申请办理中医医疗广告审查无需现场取件，请登录【四川政务服务网--{'>'}
                    个人中心--{'>'}我的办事】下载。
                </div> */}
            </Modal>
            
            <Modal
                title={
                    <div>
                        <span style={{ color: ' #faad14', fontSize: '20px', marginRight: '15px' }}>
                            <ExclamationCircleOutlined />
                        </span >
                        <span style={{ color: 'red', fontSize: '16px', marginRight: '15px' }}>
                        温馨提示：上传的《广告成品样件PDF》为A4大小,且为纵向，如下：
                        </span>
                        
                    </div>
                }
                open={openGgcpyj}
                onCancel={() => setOpenGgcpyj(false)}
                destroyOnClose={true}
                width={600}
                footer={[
                    <Button type='primary' onClick={() => setOpenGgcpyj(false)}>
                        确认
                    </Button>
                ]}
                style={{ top: '5%' }}
            >
                 {
                    <img
                        src={require('../../img/ggcpyjgz.png')}
                        className='ck-view-img'
                        draggable='false'
                        alt='广告成品样件示例'
                    />
                }
            </Modal>
        </div>
    );
};

export default Material;
